import React, { useEffect, useRef, useState } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Data = [
    {
        id: 1,
        title: "홈 화면 가이드",
        content: [
            {
                idx: 1,
                content: "홈 화면 가이드",
                img: "./images/guides/home_guide_1-1.png",
            },
            {
                idx: 2,
                content: "사내 공지사항",
                img: "./images/guides/home_guide_1-2.png",
            },
            {
                idx: 3,
                content: "의뢰인 확인 요망",
                img: "./images/guides/home_guide_1-3.png",
            },
            {
                idx: 4,
                content: "의뢰인 확인요망 - 상세 설명",
                img: "./images/guides/home_guide_1-4.png",
            },
            {
                idx: 5,
                content: "오늘의 일정",
                img: "./images/guides/home_guide_1-5.png",
            },
            {
                idx: 6,
                content: "고객의 매물 평가",
                img: "./images/guides/home_guide_1-6.png",
            },
            {
                idx: 7,
                content: "매물과 고객 접수",
                img: "./images/guides/home_guide_1-7.png",
            },
        ],
    },
    {
        id: 2,
        title: "매물 관련",
        content: [
            {
                idx: 1,
                content: "매물 상태",
                img: "./images/guides/home_guide_2-1.png",
            },
            {
                idx: 2,
                content: "대량 매물 등록",
                img: "./images/guides/home_guide_2-2.png",
            },
            {
                idx: 3,
                content: "매물 간편 접수",
                img: "./images/guides/home_guide_2-3.png",
            },
            {
                idx: 4,
                content: "매물 상세 접수",
                img: "./images/guides/home_guide_2-4.png",
            },
            {
                idx: 5,
                content: "매물 목록과 지도화면",
                img: "./images/guides/home_guide_2-5.png",
            },
            {
                idx: 6,
                content: "매물장 설정",
                img: "./images/guides/home_guide_2-6.png",
            },
            {
                idx: 7,
                content: "매물 상세화면",
                img: "./images/guides/home_guide_2-7.png",
            },
            {
                idx: 8,
                content: "AI 매칭 및 매물전송",
                img: "./images/guides/home_guide_2-8.png",
            },
            {
                idx: 9,
                content: "공동 중개",
                img: "./images/guides/home_guide_2-9.png",
            },
            {
                idx: 10,
                content: "요청과 진행 현황",
                img: "./images/guides/home_guide_2-10.png",
            },
            {
                idx: 11,
                content: "매물정보 나에게 전송",
                img: "./images/guides/home_guide_2-11.png",
            },
            {
                idx: 12,
                content: "블로그 초안 작성",
                img: "./images/guides/home_guide_2-12.png",
            },
            {
                idx: 13,
                content: "일정 캘린더 등록",
                img: "./images/guides/home_guide_2-13.png",
            },
            {
                idx: 14,
                content: "계약서 작성",
                img: "./images/guides/home_guide_2-14.png",
            },
            {
                idx: 15,
                content: "확인일 갱신",
                img: "./images/guides/home_guide_2-15.png",
            },
            {
                idx: 16,
                content: "담당자 변경",
                img: "./images/guides/home_guide_2-16.png",
            },
        ],
    },
    {
        id: 3,
        title: "고객 관련",
        content: [
            {
                idx: 1,
                content: "고객 상태",
                img: "./images/guides/home_guide_3-1.png",
            },
            {
                idx: 2,
                content: "고객 목록",
                img: "./images/guides/home_guide_3-4.png",
            },
            {
                idx: 3,
                content: "고객 접수",
                img: "./images/guides/home_guide_3-2.png",
            },
            {
                idx: 4,
                content: "고객 등록 - 희망지역 선택",
                img: "./images/guides/home_guide_3-3.png",
            },
            {
                idx: 5,
                content: "고객 상세화면",
                img: "./images/guides/home_guide_3-5.png",
            },
            {
                idx: 6,
                content: "AI 매칭 및 매물전송",
                img: "./images/guides/home_guide_3-6.png",
            },
            {
                idx: 7,
                content: "공동 중개",
                img: "./images/guides/home_guide_3-7.png",
            },
            {
                idx: 8,
                content: "공동 중개 - 요청과 현황",
                img: "./images/guides/home_guide_3-8.png",
            },
            {
                idx: 9,
                content: "전송매물",
                img: "./images/guides/home_guide_3-9.png",
            },
            {
                idx: 10,
                content: "미팅기록 작성/수정",
                img: "./images/guides/home_guide_3-10.png",
            },
            {
                idx: 11,
                content: "이탈고객 자동관리",
                img: "./images/guides/home_guide_3-11.png",
            },
            {
                idx: 12,
                content: "이탈고객 자동관리 - 현황",
                img: "./images/guides/home_guide_3-12.png",
            },
            {
                idx: 13,
                content: "일정 캘린더 등록",
                img: "./images/guides/home_guide_3-13.png",
            },
            {
                idx: 14,
                content: "담당자 변경",
                img: "./images/guides/home_guide_3-14.png",
            },
        ],
    },
    {
        id: 4,
        title: "개인/사무소 설정",
        content: [
            { idx: 1, content: "개인 설정", img: "./images/guides/home_guide_4_1.png", },
            { idx: 2, content: "사무소 관리 - 사내공지", img: "./images/guides/home_guide_4_2.png", },
            { idx: 3, content: "사무소 관리 - 사무소 정보", img: "./images/guides/home_guide_4_3.png", },
            { idx: 4, content: "직원 관리", img: "./images/guides/home_guide_4_4.png", },
            { idx: 5, content: "업무 통계 - 개인", img: "./images/guides/home_guide_4_5.png", },
            { idx: 6, content: "업무 통계 - 전직원", img: "./images/guides/home_guide_4_6.png", },
            { idx: 7, content: "외부 광고 - 아싸점포거래소", img: "./images/guides/home_guide_4_8.png", },
            { idx: 8, content: "외부 광고 - 미니홈", img: "./images/guides/home_guide_4_7.png", },
            { idx: 9, content: "소속 신청 관리", img: "./images/guides/home_guide_4_9.png", },
            { idx: 10, content: "삭제된 매물", img: "./images/guides/home_guide_4_10.png", },
            { idx: 11, content: "문의하기", img: "./images/guides/home_guide_4_11.png", },
        ],
    },
];

export default function Guide({
    viewinnerContentIdx = 1,
    viewaccordianStep = 1,
    onClose = () => { }
}) {
    // const [closeGuide, setCloseGuide] = useState(false);
    const [accordianStep, setAccordianStep] = useState(viewaccordianStep); // 대분류
    // const [innerContentData, setInnerContentData] = useState([]);
    const [innerContentData, setInnerContentData] = useState(Data.find((x) => x.id === viewaccordianStep));
    const [innerContentName, setInnerContentName] = useState(""); // 안쓰는거
    const [innerContentIdx, setInnerContentIdx] = useState(viewinnerContentIdx); // 소분류
    const swiperRef = useRef(null);

    const flashButton = (buttonRef) => {
        buttonRef.classList.add("flash");
        setTimeout(() => {
            buttonRef.classList.remove("flash");
        }, 500);
    };

    //왼쪽 버튼
    const goToPrevSlide = (e) => {
        if (swiperRef.current && swiperRef.current.swiper) {
            if (innerContentData.id === 1 && innerContentIdx === 1) {
                return;
            }
            if (innerContentIdx <= 1) {
                // setAccordianStep(innerContentData.id - 1);
                setMenuData(innerContentData.id - 1, true)
            } else {
                setInnerContentIdx(innerContentIdx - 1);
                setInnerContentName(innerContentData.content[innerContentIdx - 2].content);
            }
            // swiperRef.current.swiper.slidePrev();
        }
        flashButton(e.currentTarget);
    };

    //오른쪽 버튼
    const goToNextSlide = (e) => {
        if (swiperRef.current && swiperRef.current.swiper) {
            // 내용이 아예 끝나면 가이드 닫기
            // if (innerContentData.id === Data.length) {
            //     console.log("????????");
            //     setCloseGuide(true);
            //     return;
            // }
            if (innerContentData.id === Data.length && innerContentData?.content?.length <= innerContentIdx) {
                onClose();
                return;
            }

            //만약 innerContent내용이 끝나면 다음 accordian으로 넘어가기
            if (innerContentData?.content?.length <= innerContentIdx) {
                // setAccordianStep(innerContentData.id + 1);
                setMenuData(innerContentData.id + 1)
            } else {
                setInnerContentIdx(innerContentIdx + 1);
                setInnerContentName(innerContentData.content[innerContentIdx].content);
            }
            // swiperRef.current.swiper.slideNext();
        }
        flashButton(e.currentTarget);
    };

    const guideHeaderClk = (num) => {
        if (accordianStep !== num) {
            // setAccordianStep(num);
            // setInnerContentIdx(1);
            // setInnerContentName(
            //     Data.find((x) => x.id === num).content[0].content
            // );
            setMenuData(num)
        } else {
            // setAccordianStep(0);
        }
    };

    // 헤더 스탭에 따른 데이터 설정
    const setMenuData = (step, reverse = false) => {
        console.log(step, reverse)
        if (step < 0) {
            return;
        }

        setAccordianStep(step)
        let data = Data.find((x) => x.id === step)
        setInnerContentData(data);

        if (reverse) {

            setInnerContentIdx(data?.content?.length);
            swiperRef?.current?.swiper?.slideTo(data?.content?.length - 1, 0); // 마지막 슬라이드로 이동
        }
        else {
            setInnerContentIdx(1);
            swiperRef?.current?.swiper?.slideTo(0, 0); // 첫 슬라이드로 이동
        }
    }

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(innerContentIdx - 1); // 4번째 슬라이드로 이동 (index는 0부터 시작) ???? 4번째로 보낸다는게 뭔소리여
        }
    }, [innerContentIdx]);

    // useEffect(() => {
    //     if (accordianStep !== 0) {
    //         setInnerContentData(Data.find((x) => x.id === accordianStep));
    //         setInnerContentIdx(viewinnerContentIdx * 1 || 1);
    //         setInnerContentName(Data.find((x) => x.id === accordianStep).content[0].content);

    //         if (swiperRef.current && swiperRef.current.swiper) {
    //             swiperRef.current.swiper.slideTo(0, 0); // 첫 슬라이드로 이동
    //         }
    //     }
    //     return;
    // }, [accordianStep]);

    useEffect(()=>{
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    },[])
    return (
        // <div className={`guide_wrap ${closeGuide ? "" : "active"}`}>
        <div className={`guide_wrap active mobileviewnone`}>
            <div className="guide_wrap_left">
                <div className="accordian_wrap">
                    <div
                        className="accordian_header"
                        onClick={() => {
                            guideHeaderClk(1);
                        }}
                    >
                        <p
                            style={{
                                color: accordianStep === 1 ? "#6164A5" : "#333",
                            }}
                        >
                            홈 화면 가이드
                        </p>
                        <img
                            src={
                                accordianStep === 1
                                    ? `./images/icons/arrow_drop_up2.svg`
                                    : `./images/icons/arrow_drop_down2.svg`
                            }
                        />
                    </div>
                    <div
                        className={`accordian_content_wrap ${accordianStep === 1 ? "open" : ""
                            }`}
                    >
                        {Data[0].content.map((item, i) => (
                            <div
                                className="accordian_content"
                                key={item.idx}
                                onClick={() => {
                                    setInnerContentIdx(item.idx);
                                    setInnerContentName(item.content);
                                }}
                            >
                                <p
                                    style={{
                                        color:
                                            innerContentIdx === item.idx
                                                ? "#6164A5"
                                                : "#333",
                                        fontWeight:
                                            innerContentIdx === item.idx
                                                ? 700
                                                : 400,
                                    }}
                                >
                                    {item.content}
                                </p>
                                {innerContentIdx === item.idx && (
                                    <div className="purple_circle" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="accordian_wrap">
                    <div
                        className="accordian_header"
                        onClick={() => {
                            guideHeaderClk(2);
                        }}
                    >
                        <p
                            style={{
                                color: accordianStep === 2 ? "#6164A5" : "#333",
                            }}
                        >
                            매물 관련
                        </p>
                        <img
                            src={
                                accordianStep === 2
                                    ? `./images/icons/arrow_drop_up2.svg`
                                    : `./images/icons/arrow_drop_down2.svg`
                            }
                        />
                    </div>
                    <div
                        className={`accordian_content_wrap ${accordianStep === 2 ? "open" : ""
                            }`}
                    >
                        {Data[1].content.map((item, i) => (
                            <div
                                className="accordian_content"
                                key={item.idx}
                                onClick={() => {
                                    setInnerContentIdx(item.idx);
                                    setInnerContentName(item.content);
                                }}
                            >
                                <p
                                    style={{
                                        color:
                                            innerContentIdx === item.idx
                                                ? "#6164A5"
                                                : "#333",
                                        fontWeight:
                                            innerContentIdx === item.idx
                                                ? 700
                                                : 400,
                                    }}
                                >
                                    {item.content}
                                </p>
                                {innerContentIdx === item.idx && (
                                    <div className="purple_circle" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="accordian_wrap">
                    <div
                        className="accordian_header"
                        onClick={() => {
                            guideHeaderClk(3);
                        }}
                    >
                        <p
                            style={{
                                color: accordianStep === 3 ? "#6164A5" : "#333",
                            }}
                        >
                            고객 관련
                        </p>
                        <img
                            src={
                                accordianStep === 3
                                    ? `./images/icons/arrow_drop_up2.svg`
                                    : `./images/icons/arrow_drop_down2.svg`
                            }
                        />
                    </div>
                    <div
                        className={`accordian_content_wrap ${accordianStep === 3 ? "open" : ""
                            }`}
                    >
                        {Data[2].content.map((item, i) => (
                            <div
                                className="accordian_content"
                                key={item.idx}
                                onClick={() => {
                                    setInnerContentIdx(item.idx);
                                    setInnerContentName(item.content);
                                }}
                            >
                                <p
                                    style={{
                                        color:
                                            innerContentIdx === item.idx
                                                ? "#6164A5"
                                                : "#333",
                                        fontWeight:
                                            innerContentIdx === item.idx
                                                ? 700
                                                : 400,
                                    }}
                                >
                                    {item.content}
                                </p>
                                {innerContentIdx === item.idx && (
                                    <div className="purple_circle" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="accordian_wrap">
                    <div
                        className="accordian_header"
                        onClick={() => {
                            guideHeaderClk(4);
                        }}
                    >
                        <p
                            style={{
                                color: accordianStep === 4 ? "#6164A5" : "#333",
                            }}
                        >
                            개인/사무소 설정
                        </p>
                        <img
                            src={
                                accordianStep === 4
                                    ? `./images/icons/arrow_drop_up2.svg`
                                    : `./images/icons/arrow_drop_down2.svg`
                            }
                        />
                    </div>
                    <div
                        className={`accordian_content_wrap ${accordianStep === 4 ? "open" : ""
                            }`}
                    >
                        {Data[3].content.map((item, i) => (
                            <div
                                className="accordian_content"
                                key={item.idx}
                                onClick={() => {
                                    setInnerContentIdx(item.idx);
                                    setInnerContentName(item.content);
                                }}
                            >
                                <p
                                    style={{
                                        color:
                                            innerContentIdx === item.idx
                                                ? "#6164A5"
                                                : "#333",
                                        fontWeight:
                                            innerContentIdx === item.idx
                                                ? 700
                                                : 400,
                                    }}
                                >
                                    {item.content}
                                </p>
                                {innerContentIdx === item.idx && (
                                    <div className="purple_circle" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="guide_wrap_right">
                <Swiper
                    ref={swiperRef}
                    modules={[]}
                    className="right_swiper"
                    allowTouchMove={false}
                >
                    {innerContentData?.content?.map((x, i) => {
                        return (
                            <SwiperSlide key={i}>
                                <img src={x.img} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <div className="right_swiper_controller_wrap">
                    <div
                        className="guide_close"
                        onClick={() => {
                            // setCloseGuide(true);
                            onClose();
                        }}
                    >
                        <p>가이드 닫기</p>
                        <img src={`./images/icons/close-circle-fill.svg`} />
                    </div>
                    <div className="right_swiper_controller">
                        <div
                            className="pagination_btn go_left"
                            onClick={goToPrevSlide}
                        >
                            <img src={`./images/icons/arrow_btn.svg`} />
                            <p>이전</p>
                        </div>
                        <div className="paging">
                            <p>{Data?.find(item => item?.id * 1 === accordianStep)?.content?.find(item => item?.idx * 1 === innerContentIdx)?.content}</p>
                            <div>
                                {innerContentIdx}
                                <span>
                                    /{innerContentData?.content?.length || 0}
                                </span>
                            </div>
                        </div>
                        <div
                            className="pagination_btn go_right"
                            onClick={goToNextSlide}
                        >
                            <p>다음</p>
                            <img src={`./images/icons/arrow_btn.svg`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
